import React, { Component } from "react";
import { isMobile } from '@/utils/common'
import './index.less'

interface Props {}
interface State {}

export default class HeaderModule extends Component<Props, State> {
  refs: any = React.createRef()
  constructor(props: Props) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <ul className={'web-info ' + (isMobile() ? 'mobile' : 'pc')}>
        <li>
          <span>网站备案号：<a target="_blank" href="https://beian.miit.gov.cn" rel="noreferrer">皖ICP备2023027970号-9</a></span>
          <span>违法和不良信息举报邮箱：<a href="mailto:kefu@love-uu.com">kefu@love-uu.com</a></span>
        </li>
        <li>
          <span>联系方式：<a href="tel:05628292966">05628292966</a></span>
          <span>工作日: 10:00-22:00</span>
        </li>
        <li><span><a target="_blank" href="https://www.12377.cn/jbxzxq/zpljbxzxq.html" rel="noreferrer">电信诈骗举报专区</a></span></li>
      </ul>
    )
  }
}